export default __webpack_public_path__ + "static/media/empty-wishlist.ad5827f9.svg";